import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import update from 'immutability-helper';
import EntryItem from './EntryItem';
import InfiniteList from '@/plugins/YoutubeSearch/components/content/InfiniteList';

const SEARCH_URL = `/plugin/AddLinkToPostWithSearch/entries`;
const BLANK_PAGE = 0; // 아무 데이터도 없는 첫 페이지.

class AddPostLinkModalBody extends Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    restoreLastSelection: PropTypes.func.isRequired,
  };

  state = {
    queryString: '',  // 검색어
    page: BLANK_PAGE, // 마지막 요청 페이지
    entries: [],      // 글 목록
    message: '',      // (목록을 가리고) 중앙에 노출할 메시지
    onFetching: false,// 서버 응답을 기다리고 있는지 여부
    hasMore: true     // 서버에 데이터가 더 존재하는지 여부
  }

  /**
   * setState 를 await 으로 호출할 수 있도록 랩핑한 함수 입니다.
   */
  asyncSetState = (state) => {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  search = async ({ renew }) => {
    await this.asyncSetState({
      page: renew ? BLANK_PAGE : this.state.page,
      entries: renew ? [] : this.state.entries,
      message: '',
      onFetching: true,
      hasMore: true,
    });

    const nextPage = this.state.page + 1;
    const res = await axios.get(SEARCH_URL, {
      params: {
        keyword: this.state.queryString,
        page: nextPage,
      },
    });

    if (res.status !== 200 || !res.data.hasOwnProperty('entries')) {
      // 서버 에러가 리턴된 경우.
      this.setState({
        page: BLANK_PAGE,
        entries: [],
        message: '문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
        onFetching: false,
        hasMore: false,
      });
      return;
    }

    const { data } = res;
    const newEntries = renew ? data.entries : update(this.state.entries, { $push: data.entries });
    const hasMore = newEntries.length < data.total;
    let message = '';
    if (newEntries.length === 0) {
      if (this.state.queryString === '') {
        message = '아직 작성한 발행 글이 없습니다.';
      } else {
        message = '검색 결과가 없습니다.';
      }
    }

    this.setState({
      page: data.page,
      entries: newEntries,
      message,
      onFetching: false,
      hasMore,
    });
  }

  searchNew = async () => {
    await this.search({ renew: true });
  }

  fetchMore = async () => {
    if (!this.state.onFetching) {
      await this.search({ renew: false });
    }
  }

  onClickEntry = entry => {
    const { closeModal, restoreLastSelection } = this.props;
    const editor = window.tinymce.activeEditor;
    const html = `<p><a href="${entry.url}" target="_blank" rel="noopener">${entry.content}</a></p>`;
    restoreLastSelection();
    editor.insertContent(html);
    closeModal();
  }

  changedQueryInput = e => {
    this.setState({ queryString: e.target.value });
  }

  handleEnterPress = async ({ key }) => {
    if (key === 'Enter') {
      await this.searchNew();
    }
  }

  render () {
    const { closeModal } = this.props;
    const { queryString, entries, message, onFetching, hasMore } = this.state;
    const { page, searchNew, fetchMore, onClickEntry, changedQueryInput, handleEnterPress } = this;
    const isFirstLoading = page === 1 && entries.length === 0 && onFetching;
    let wrapListChildren;
    if (isFirstLoading) {
      wrapListChildren = <FirstLoading />;
    } else if (message) {
      wrapListChildren = <Message message={message} />;
    } else {
      wrapListChildren = (<InfiniteList className={'list_editor'}
        fetchMore={fetchMore}
        isFetchingMore={onFetching}
        spinner={<Loading />}
        hasMore={hasMore} >
        {entries.map((entry, index) => <EntryItem key={index} entry={entry} onClick={onClickEntry} />
        )}
      </InfiniteList>
      );
    }

    return (
      <div className="editor_layer_type4">
        <div className="inner_editor_layer inner_perview_layer">
          <div className="head_layer">
            <strong className="tit_head">이전 발행 글 넣기</strong>
            <div className="search_item">
              <strong className="screen_out">검색</strong>
              <div className="inp_text">
                <input type="text" id="editorSearch" placeholder="검색어를 입력하세요." title="검색"
                  value={queryString}
                  onChange={changedQueryInput}
                  onKeyPress={handleEnterPress}
                />
              </div>
              <button type="submit" className="btn_search" onClick={searchNew}><span className="ico_editor ico_search">검색</span></button>
            </div>
          </div>
          <div className="cont_layer">
            <div className="wrap_list">
              {wrapListChildren}
            </div>
          </div>
          <div className="foot_layer">
            <div className="fld_btn">
              <button type="button" className="btn" onClick={closeModal} >닫기</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function FirstLoading () {
  return (
    <div className="info_none">
      <span className="ico_blog ico_loading ico_loading_type1">로딩중입니다</span>
    </div>
  );
}

function Message ({ message }) {
  return (
    <div className="info_none">
      <div className="txt_none">
        {message}
      </div>
    </div>
  );
}

function Loading () {
  return (
    <li className="info_loading">
      <span className="ico_blog ico_loading">로딩중입니다</span>
    </li>
  );
}

export default AddPostLinkModalBody;
